import type { ComponentPropsWithoutRef } from 'react';
import { cx } from '../../utils/cx';
import s from './Divider.module.css';

export type DividerProps = ComponentPropsWithoutRef<'hr'> & {
  /** Optional centered label, e.g. "or use email". */
  label?: string;
};

export function Divider({ label, className, ...rest }: DividerProps) {
  if (!label) return <hr className={cx(s.rule, className)} {...rest} />;
  return (
    <div className={cx(s.labeled, className)} role="separator" aria-label={label}>
      <span aria-hidden="true">{label}</span>
    </div>
  );
}
